module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/couch-illustration-b356681ab93a811e6b7352b455a5b111.svg";